/**
 * Determines tab visibility based on answer_type and analysis_mode.
 *
 * @param {string|null} answerType - One of: "sql", "api", "rag", "mixed", "clarification", "unknown", or null
 * @param {string} analysisMode - "deep" or "fast"
 * @param {boolean} hasSummary - Whether an answer_summary is present (fast mode only)
 * @param {boolean} hasInsights - Whether the insights/description tab has content
 * @returns {{ showTabs: boolean, visibleTabs: string[], defaultTab: string|null }}
 */
export const getTabConfig = (answerType, analysisMode = 'deep', hasSummary = false, hasInsights = false) => {
  // No answer_type yet (still loading) or tabless types
  if (!answerType || answerType === 'rag' || answerType === 'clarification' || answerType === 'unknown') {
    return { showTabs: false, visibleTabs: [], defaultTab: null };
  }

  // sql, api, mixed — show tabs
  if (analysisMode === 'deep') {
    return {
      showTabs: true,
      visibleTabs: ['data', 'source', 'description'],
      defaultTab: hasInsights ? 'description' : 'data',
    };
  }

  // fast mode: include summary tab only when answer_summary is present
  const hasDescriptionTab = hasSummary || hasInsights;
  return {
    showTabs: true,
    visibleTabs: hasDescriptionTab ? ['data', 'source', 'description'] : ['data', 'source'],
    defaultTab: hasDescriptionTab ? 'description' : 'data',
  };
};
